import { useContext, useEffect } from "react";
import { AppContext } from "../../contexts/AppContext";
import { useParams } from "react-router-dom";
import SurplusManagement from "../../components/SurplusManagement";

const SurplusManagementPage: React.FC = () => {
  const { findAndSetStore } = useContext(AppContext);
  const { storeId } = useParams<{ storeId: string }>();

  useEffect(() => {
    if (!storeId) return;
    findAndSetStore(storeId);
  }, [storeId]);

  return <SurplusManagement />;
};

export default SurplusManagementPage;
